export default __webpack_public_path__ + "static/media/Just_4_logo_blue.2c36d3a5.svg";